'use client';

export default function TermsAndConditions() {
  return (
    <main className="px-8 lg:px-24 my-12 lg:my-16 lg:pr-10 lg:pt-4 dark:bg-background-dark">
      <div className="mx-auto my-6">
        <h1 className="text-4xl font-bold mb-6">Terms and Conditions</h1>
        <p className="text-lg mb-8">Last Updated: February 10, 2025</p>
      </div>

      <div className="space-y-8">
        <section>
          <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mb-4">
            1. Agreement to Terms
          </h2>
          <p className="mb-4">
            By accessing or using SupplySense 360&apos;s platform, you agree to these Terms and Conditions. Our platform provides real-time shipment tracking, smart quotation capabilities, landed cost calculation, and tariff database access.
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mb-4">
            2. Platform Access and Account Management
          </h2>
          <p className="mb-4">
            - You must be at least 18 years old to use our platform<br />
            - Registration requires a valid email address<br />
            - You are responsible for maintaining account confidentiality<br />
            - Demo access is provided for testing purposes only
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mb-4">
            3. Data Integration and API Usage
          </h2>
          <p className="mb-4">
            - EDI and API integrations must follow our technical specifications<br />
            - You are responsible for the accuracy of submitted data<br />
            - API access is subject to rate limiting and fair usage policies<br />
            - Integration credentials must be kept secure
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mb-4">
            4. Service Availability and Updates
          </h2>
          <p className="mb-4">
            - We strive for 99.9% platform availability<br />
            - Scheduled maintenance will be communicated in advance<br />
            - Platform features may be updated or modified periodically<br />
            - Service alerts will be sent via email or platform notifications
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mb-4">
            5. Subscription and Payment Terms
          </h2>
          <p className="mb-4">
            - All subscription terms, including renewals, cancellations, and payment terms are governed by the Master Service Agreement (MSA) executed between your organization and Transport Analytics, LLC and/or its subsidiaries<br />
            - Changes to pricing will be communicated as specified in the MSA<br />
            - Refund policies and procedures are subject to the terms outlined in the MSA<br />
            - Billing cycles and payment methods are established in the MSA
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mb-4">
            6. User Obligations
          </h2>
          <p className="mb-4">
            You agree to:<br />
            - Provide accurate shipping and quotation information<br />
            - Use the platform for legitimate business purposes<br />
            - Comply with applicable shipping and trade regulations<br />
            - Maintain accurate business, customer and user profile information
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mb-4">
            7. Intellectual Property
          </h2>
          <p className="mb-4">
            - The SupplySense 360 platform, including all its features, functionalities, and associated intellectual property rights, are owned exclusively by Transport Analytics, LLC and its subsidiaries<br />
            - You retain ownership of your submitted data<br />
            - Limited license granted for platform usage<br />
            - No unauthorized reproduction of platform content
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mb-4">
            8. Limitation of Liability
          </h2>
          <p className="mb-4">
            - Service provided &quot;as is&quot; without warranties<br />
            - Not liable for shipping delays or third-party issues<br />
            - Liability limited to fees paid for service<br />
            - Force majeure conditions apply
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mb-4">
            9. Term and Termination
          </h2>
          <p className="mb-4">
            - Term and termination conditions are governed by the MSA<br />
            - Account deletion from demo environment requires written request<br />
            - Data handling and export procedures will be as specified in the MSA<br />
            - Certain provisions may survive termination as detailed in the MSA
          </p>
        </section>

        <section>
          <h2 className="text-xl font-semibold text-gray-800 dark:text-gray-100 mb-4">
            10. Governing Law
          </h2>
          <p className="mb-4">
            These terms are governed by the laws of the State of Texas. Any disputes will be resolved through arbitration as specified in our Dispute Resolution Policy.
          </p>
        </section>

        <section className="mt-12">
          <p className="text-lg">
            Contact us at{' '}
            <a href="mailto:legal@supplysense360.com"
className="text-blue-600 hover:text-blue-800 dark:text-blue-400 dark:hover:text-blue-300">
              legal@supplysense360.com
            </a>{' '}
            for any questions about these terms.
          </p>
        </section>
      </div>
    </main>
  );
}